// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__DjQ9e","icon":"style_icon__2t3L5"};